import { getstg } from '../utils';
export const urlstartpage = (defaultMuni = '0301') => {
    var _a, _b;
    return `#kommuner/${(_b = (_a = getstg().preferences) === null || _a === void 0 ? void 0 : _a.favorite) !== null && _b !== void 0 ? _b : defaultMuni}`;
};
